import StringListFilter from "@search/store/filters/primitive/StringListFilter";

class BoardBasisFilter extends StringListFilter {
  constructor(value: Array<string>) {
    super({ label: "board basis", name: "boardBasis", value });
  }
}

export default BoardBasisFilter;
export { BoardBasisFilter };
